const getTheme = (state) => {
    return state.themes;
};

export default {
    getTheme
}